import { render } from "./inStock.vue?vue&type=template&id=18cf2eca&scoped=true"
import script from "./inStock.vue?vue&type=script&lang=js"
export * from "./inStock.vue?vue&type=script&lang=js"

import "./inStock.vue?vue&type=style&index=0&id=18cf2eca&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-18cf2eca"

export default script